'use client'

import { signOut as signOutNexAuth, useSession } from 'next-auth/react'

import configuration from '~/configuration'
import useMiddlewareRequest from '~/core/middleware/use-middleware-request'

import { useRouterContext } from '~/lib/next/use-router-context'

export function useSubmitSignOut() {
  const { locale } = useRouterContext()
  const { data: session } = useSession()
  const { trigger, isMutating, data, error } = useMiddlewareRequest({
    endpoint: configuration.api.signOut,
    method: 'POST',
    locale
  })

  const handleSignOut = async () => {
    trigger({}).then(async (result) => {
      if (result.success) {
        if (session) {
          await signOutNexAuth({ redirect: false })
        }
        window.location.href = configuration.path.login
      }
    })
  }

  return {
    handleSignOut,
    isLoading: isMutating,
    data,
    error
  }
}
